import { render, staticRenderFns } from "./StoryDocument.vue?vue&type=template&id=f8c13f24"
import script from "./StoryDocument.vue?vue&type=script&lang=js"
export * from "./StoryDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports